/**
 * A fold that opens and closes by growing its own height (the admin's How to prepare fold,
 * shared with the client's History, Gabriel 2026-10-06). The content stays mounted, hidden from
 * assistive tech while closed. Each skin lays out the content with `innerClassName`.
 */
import type { ReactNode } from 'react';
import styles from './FoldPanel.module.css';

export function FoldPanel({ open, innerClassName, children }: { open: boolean; innerClassName?: string; children: ReactNode }) {
  return (
    <div className={styles.panel} data-open={open || undefined}>
      <div className={innerClassName ? `${styles.inner} ${innerClassName}` : styles.inner} aria-hidden={!open}>
        {children}
      </div>
    </div>
  );
}
